module.exports = "<header></header>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = ./src/app/header/header.component.html
// module chunks = main